export default __webpack_public_path__ + "static/media/blue-user-list.58c3eaf9.svg";